import { create } from "zustand";
import agent from "../services/api";
import { carouselTemplateGroup, CommonResponseModel, getTemplateDetails, getWhatsappTemplateTypeResponse } from "../models/axiosModel";

interface carouselTemplateGroupStoreInterface {
    carouselTemplateGroupData: carouselTemplateGroup[] | null,
    setCarouselTemplateGroupData: (value: carouselTemplateGroup[] | null) => void,

    getCarouselTemplateGroups: (meta_integration_whatsapp_id?: number) => Promise<CommonResponseModel<carouselTemplateGroup>>,

    carouselTemplateGroupList: carouselTemplateGroup[] | null,
    setCarouselTemplateGroupList: (value: carouselTemplateGroup[] | null) => void,

    flagCreateTemplateGroupPopup: boolean,
    setFlagCreateTemplateGroupPopup: (value: boolean) => void,

    selectedTemplateGroup: carouselTemplateGroup | null,
    setSelectedTemplateGroup: (value: carouselTemplateGroup | null) => void,

    carouselTemplateList: getTemplateDetails[] | null,
    setCarouselTemplateList: (value: getTemplateDetails[] | null) => void,

    getCarouselTemplateList: (meta_integration_whatsapp_id: number, whatsapp_template_type_id: number) => Promise<CommonResponseModel<getTemplateDetails>>,

    whatsAppTemplateTypes: getWhatsappTemplateTypeResponse[] | null,
    setWhatsAppTemplateTypes: (value: getWhatsappTemplateTypeResponse[] | null) => void,

    getWhatsappTemplateTypes: () => Promise<CommonResponseModel<getWhatsappTemplateTypeResponse>>,
}

export const useCarouselTemplateGroupStore = create<carouselTemplateGroupStoreInterface>((set) => ({
    carouselTemplateGroupData: null,
    setCarouselTemplateGroupData: (value: carouselTemplateGroup[] | null) => set({ carouselTemplateGroupData: value }),

    getCarouselTemplateGroups: async (meta_integration_whatsapp_id?: number) => {
        const res = await agent.getCarouselTemplateGroups.get(meta_integration_whatsapp_id);
        if (res.status) {
            if(meta_integration_whatsapp_id){
                set({ carouselTemplateGroupData: res?.data });
            } else {
                set({ carouselTemplateGroupList: res?.data });
            }
        } else {
            if(meta_integration_whatsapp_id){
                set({ carouselTemplateGroupData: null });
            } else {
                set({ carouselTemplateGroupList: null });
            }
        }
        return res;
    },

    carouselTemplateGroupList: null,
    setCarouselTemplateGroupList: (value: carouselTemplateGroup[] | null) => set({ carouselTemplateGroupList: value }),

    flagCreateTemplateGroupPopup: false,
    setFlagCreateTemplateGroupPopup: (value: boolean) => set({ flagCreateTemplateGroupPopup: value }),

    selectedTemplateGroup: null,
    setSelectedTemplateGroup: (value: carouselTemplateGroup | null) => set({ selectedTemplateGroup: value }),

    carouselTemplateList: null,
    setCarouselTemplateList: (value: getTemplateDetails[] | null) => set({ carouselTemplateList: value }),

    getCarouselTemplateList: async (meta_integration_whatsapp_id: number, whatsapp_template_type_id: number) => {
        const res = await agent.getWhatsappTemplateList.get(meta_integration_whatsapp_id, whatsapp_template_type_id);
        if (res.status) {
            set({ carouselTemplateList: res?.data });
        } else {
            set({ carouselTemplateList: null });
        }
        return res;
    },

    whatsAppTemplateTypes: null,
    setWhatsAppTemplateTypes: (value: getWhatsappTemplateTypeResponse[] | null) => set({ whatsAppTemplateTypes: value }),

    getWhatsappTemplateTypes: async () => {
        const res = await agent.getWhatsappTemplateType.get();
        if (res.status) {
            set({ whatsAppTemplateTypes: res?.data });
        } else {
            set({ whatsAppTemplateTypes: null });
        }
        return res;
    }
}))